module.exports = __webpack_public_path__ + "img/canInvitation.3c104db1.png";